export default __webpack_public_path__ + "static/media/arrow-down-small-white.758bea43.svg";